// récup de general/gestion_roles/static/js/tenue-a-jour.js


/**
 * Initialisation des révisions administratives.
 * lancé dynamiquement par loadPage /
 * if (typeof window['init_' + initCurrentNomModule] === "function") window['init_' + initCurrentNomModule](currentIdModule);
 * récup de function init_tenue_a_jour()
 */
function init_revisions_administratives() {
   $('.section-rapport:visible').each(function () {
        initRapportRevisionAdministrative($(this));
    });
    revisionsAdministrativesBoutons.initEvenementsJQuery();
}


// Espace de nom réservé à l'utilisation des boutons et de leurs actions (global)
var revisionsAdministrativesBoutons = {
    initEvenementsJQuery: function () {

        $('#btn-revisions-administratives-creer-demande-revision').off('click').on('click', function () {
           revisionsAdministrativesBoutons.ouvrirCreerDemandeDeRevision();
        });

        $('#btn-revisions-administratives-creer-recours-tribunal').off('click').on('click', function () {
           revisionsAdministrativesBoutons.ouvrirCreerRecoursAuTribunal();
        });

        $('#btn-revisions-administratives-creer-correction-office').off('click').on('click', function () {
           revisionsAdministrativesBoutons.ouvrirCreerCorrectionDOffice();
        });

        $('#btn-revisions-administratives-creer-correction-erreur-ecriture').off('click').on('click', function () {
           revisionsAdministrativesBoutons.ouvrirCreerCorrectionErreurEcriture();
        });


    },

    // au click du bouton de création de demande de revision: lance la modale d'assistant d'evenements
    ouvrirCreerDemandeDeRevision: function () {
        revisionsAdministrativesBoutons.ajaxWizardNouveauEvenement(61);
    },

    ouvrirCreerRecoursAuTribunal: function () {
        revisionsAdministrativesBoutons.ajaxWizardNouveauEvenement(62);
    },

    ouvrirCreerCorrectionDOffice: function () {
        revisionsAdministrativesBoutons.ajaxWizardNouveauEvenement(63);
    },

    ouvrirCreerCorrectionErreurEcriture: function () {
        revisionsAdministrativesBoutons.ajaxWizardNouveauEvenement(64);
    },

    // Gestion de la modale wizard de création d'événement
    ajaxWizardNouveauEvenement: function (type_evenement) {
        $.ajax({
            type: "GET",
            url: `/gestion-roles/tenue-a-jour/wizard/type_evenement/${type_evenement}/nouveau/`,
            dataType: 'html',
            success: function (response) {
                var m = $('#tenue-a-jour-modal-creer-evenement');
                m.remove();
                $(this).data('modal', null);
                // et vient gérer l'affichage de notre formulaire pour l'étape dans la modale
                // grace au contenu de notre étape dans etape_processus qui contient l'url et 2 callbacks
                // ouvrir_demande_revision_informations_generales
                // init: initDemandeRevisionInformationsGenerales
                // save: saveDemandeRevisionInformationsGenerales
                tenueAJourModal.PostTraitementOuvrirWizardEvenement(response, {});
            }
        });
    },

};

$("body").on("change", "#table-revisions-administratives_wrapper input[type='checkbox']", function() {
    if($(this).attr('name') == 'check-tj-select-all') {
        gerer_checkbox_select_all(this);
    }
    else {
        gerer_checkbox_taj(this);
    }
});

function gerer_checkbox_taj(checkbox_change) {
    let evenement_selectionne = $(checkbox_change).closest("tr").attr("data-id_evenement");
    let selecteur = "tr[data-id_evenement='" + evenement_selectionne + "']";
    let statut_checkbox_change = $(checkbox_change).is(":checked");

    $(selecteur).each(function() {
        let ma_checkbox = $(this).find("input[type='checkbox']");
        if($(ma_checkbox).is(':checked') !== statut_checkbox_change) {
            $(ma_checkbox).click();
        }
    });
}

function gerer_checkbox_select_all(checkbox_change) {
    let statut_checkbox_change = $(checkbox_change).is(":checked");

    $('#table-revisions-administratives_wrapper .DTFC_ScrollWrapper input[type="checkbox"]').each(function() {
        if($(this).is(':checked') !== statut_checkbox_change) {
            $(this).click();
        }
    });
}

var revisionsAdministrativesModal = {
    //////////////////////////////////////////////////////
    // DDR
    //////////////////////////////////////////////////////
    // à l'ouverture de la modale, demande révision, étape informations générale callback.
    // Provient de la bd etape_processus.vue_variables : init
    initDemandeDeRevisionInformationsGenerales: function(){
        tenueAJourModal.initInfoGeneraleCommun();
        $('#modal-step1').attr('recharger', 'oui');
        $('button#btn-wizard-save').prop('disabled', true);  // sera activé quand changement dans le form


        var id_evenement = $('#wizard').attr('id-evenement');
        var id_ue = $('#wizard').attr('id-ue');

        // Pas en mode création.
        // En mode édition / Mode Lecture seule (dans TAJ également) quand on revient à l'étape 1
        if(id_evenement && id_ue){
            ////////////////////////////////////////////////
            // Gestion du selecteur demandeur nature / selecteur proprietaire
            //
            let id_proprietaire = $("#demande-de-revision").attr('id-demandeur_proprietaire_id');
            // récupération de la liste des propriétaires, avec le potentiel id_proprieraire sélectionné si présent.
            revisionsAdministrativesModal.getDDRProprietairesListe(id_ue, id_proprietaire, function(response){
                // remplacement du contenu du dom par le html retourné.
                $('#ddr-form-proprietaire').html(response);
                // simule un changement du sélecteur de demandeur nature, afin d'afficher les bons "sous-champs"
                $('#demande-de-revision #demandeur_nature').change();
                // masque la div d'avertissement de sékection d'UE
                $("#ddr-form-proprietaire-aucun-id-ue").hide();
                // affiche le formulaire ayant le selecteur
                $("#ddr-form-proprietaire").show();
                // le changement du dropdown provoque un changement du fomrulaire,
                // étant toujours dans l'initialisation, on redésactive le bouton de sauvegarde
                $('button#btn-wizard-save').prop('disabled', true);
            });
            ////////////////////////////////////////////////
            // Gestion du selecteur evenement
            //
            let id_evenement = $("#demande-de-revision").attr('id-evenement_origine_ddr_id');
            // récupération de la liste des evenements, avec le potentiel id_evenement sélectionné si présent.
            revisionsAdministrativesModal.getDDREvenementsListe(id_ue, id_evenement, revisionsAdministrativesModal.callBack_defaut_getDDREvenementsListe);

        }

        //////////////////////////////////
        // interactions formulaire ddr:
        //
        // Affichage du selecteur de propriétaire ou du formulaire d'adresse en fonction de la nature du demandeur
        $('#demande-de-revision #demandeur_nature').on('change', function(e){
            // masque les deux sections par défaut
            $('#demande-de-revision #ddr-form-proprietaire-selection').hide();
            $('#demande-de-revision #ddr-form-demandeur-details').hide();
            if($(this).val()=="0"){
                $('#demande-de-revision #ddr-form-proprietaire-selection').show();
            }else if($(this).val()=="1"){
                $('#demande-de-revision #ddr-form-demandeur-details').show();
            }
        });



    }, // initDemandeDeRevisionInformationsGenerales

    // pour le click d'un résultat de sélection d'UE,
    // apellé depuis explorateur-ue-recherche.js
    callbackSelectionUEpourDDR: function(element_a_clique, evenement_du_click, checkboxEstCoche){
        var id_ue_dernier_click = $(element_a_clique).attr('id-ue');
        var id_ue = id_ue_dernier_click; //1035919;
        revisionsAdministrativesModal.getDDRProprietairesListe(id_ue, null, function(response){
            $('#ddr-form-proprietaire').html(response);
            $("#demande-de-revision #ddr-form-proprietaire-aucun-id-ue").hide();
            $("#demande-de-revision #ddr-form-proprietaire").show();

        });
        revisionsAdministrativesModal.getDDREvenementsListe(id_ue, null, revisionsAdministrativesModal.callBack_defaut_getDDREvenementsListe);
    },
    // Call ajax qui nous récupère le html de la liste des propriétaires, fournir un callback pour traiter le retour.
    getDDRProprietairesListe: function(id_ue, id_proprietaire, callback_getDDRProprietairesListe){
        $.ajax({
            type: "POST",
            url: "/gestion-roles/revisions-administratives/demande-revision/informations-generales/proprietaires-liste/"+id_ue+'/',
            data: {id_proprietaire: id_proprietaire},
            dataType: 'html',
            success: function (response) {
                callback_getDDRProprietairesListe(response);
            }

        });
    },
    // Call ajax qui nous récupère le html de la liste des évènements pour l'ue sélectionnée, fournir un callback pour traiter le retour.
    getDDREvenementsListe: function(id_ue, id_evenement, callback_getDDREvenementsListe){
        $.ajax({
            type: "POST",
            url: "/gestion-roles/revisions-administratives/demande-revision/informations-generales/evenements-liste/"+id_ue+'/',
            data: {id_evenement: id_evenement},
            dataType: 'html',
            success: function (response) {callback_getDDREvenementsListe(response);}
        });
    },
    callBack_defaut_getDDREvenementsListe: function(response){
        // remplacement du contenu du dom par le html retourné.
        $('#ddr-form-evenement').html(response);
        $('#ddr-form-evenement').show();
        $("#ddr-form-evenement-aucun-id-ue").hide();
                // lorsqu'un evenement d'origine est sélectionné, on propose à l'utilisateur de MAJ la Date de prise d'effet au rôle de l'event.
        $('#evenement_origine_ddr').on('change',function(e){
            let date_evenement_origine = $('#evenement_origine_ddr > option:selected').data('date_evenement');
            let date_evenement_prise_effet = $('[name="date_evenement"]').val();
            // si on a un evenement avec une date de  selectionné ET que c'est différent de la date déja renseignée
            if(date_evenement_origine && (date_evenement_prise_effet != date_evenement_origine)){

                fenetreModal.modalMessage({
                    enteteTitre:'Attention',
                    titre: "Remplacer la date de prise d'effet?",
                    texteExplicatif: "Souhaitez-vous mettre à jour la date de prise d'effet au rôle de l'évènement ("+date_evenement_prise_effet+") par " +
                        "celle de l'évènement d'origine sélectionné ("+date_evenement_origine+")?",
                    conteneur: "#page_content",
                    taille: "grande",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {
                                $('[name="date_evenement"]').val(date_evenement_origine);
                                $('[name="date_evenement"]').change();
                                fenetreModal.fermerModalAlerteDivs();
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                                fenetreModal.fermerModalAlerteDivs();
                            }
                        }
                    }
                });//fenetreModal
            } //if(date_evenement_selection...
        }); //$('#evenement_origine_ddr').off('change')...

    },
    // Pour Recours Au Tribunal
    callBack_defaut_getRATEvenementsListe: function(response){
        // remplacement du contenu du dom par le html retourné.
        $('#rat-form-evenement').html(response);
        $('#rat-form-evenement').show();
        $("#rat-form-evenement-aucun-id-ue").hide();
        $('#evenement_origine_rat').on('change',function(e){
            let date_evenement_origine = $('#evenement_origine_rat > option:selected').data('date_evenement');
            let date_evenement_prise_effet = $('[name="date_evenement"]').val();
            // si on a un evenement avec une date de selectionné ET que c'est différent de la date déja renseignée
            if(date_evenement_origine && (date_evenement_prise_effet != date_evenement_origine)){
                fenetreModal.modalMessage({
                    enteteTitre:'Attention',
                    titre: "Remplacer la date de prise d'effet?",
                    texteExplicatif: "Souhaitez-vous mettre à jour la date de prise d'effet au rôle de l'évènement ("+date_evenement_prise_effet+") par " +
                        "celle de l'évènement d'origine sélectionné ("+date_evenement_origine+")?",
                    conteneur: "#page_content",
                    taille: "grande",
                    boutons: {
                        "Oui": {
                            label: " Oui ",
                            id: "",
                            class: "btn btn-success",
                            action: function () {
                                $('[name="date_evenement"]').val(date_evenement_origine);
                                $('[name="date_evenement"]').change();
                                fenetreModal.fermerModalAlerteDivs();
                            }
                        },
                        "Non": {
                            label: " Non ",
                            id: "",
                            class: "btn",
                            action: function () {
                                fenetreModal.fermerModalAlerteDivs();
                            }
                        }
                    }
                });//fenetreModal
            } //if(date_evenement_origine...
        }); //$('#evenement_origine_rat').off('change')...
    },
    // pour le click d'un résultat de sélection d'UE depuis explorateur-ue-recherche.js
    callbackSelectionUEpourRAT: function(element_a_clique, evenement_du_click, checkboxEstCoche){
        var id_ue_dernier_click = $(element_a_clique).attr('id-ue');
        var id_ue = id_ue_dernier_click; //1035919;
        revisionsAdministrativesModal.getDDRProprietairesListe(id_ue, null, function(response){
            $('#rat-form-proprietaire').html(response);
            $("#recours-au-tribunal #rat-form-proprietaire-aucun-id-ue").hide();
            $("#recours-au-tribunal #rat-form-proprietaire").show();

        });
        revisionsAdministrativesModal.getRATEvenementsListe(id_ue, null, revisionsAdministrativesModal.callBack_defaut_getRATEvenementsListe);
    },
    getRATEvenementsListe: function(id_ue, id_evenement, callback_getRATEvenementsListe){
        $.ajax({
            type: "POST",
            url: "/gestion-roles/revisions-administratives/recours-au-tribunal/informations-generales/evenements-liste/"+id_ue+'/',
            data: {id_evenement: id_evenement},
            dataType: 'html',
            success: function (response) {callback_getRATEvenementsListe(response);}
        });
    },

    // au clic du bouton sauvegarder (ou étape suivante...)
    // Provient de la bd etape_processus.vue_variables : save
    saveDemandeDeRevisionInformationsGenerales: function(callback){
        $('#modal-step1').attr('recharger', 'oui');
        tenueAJourModal.checkDateDeJour(revisionsAdministrativesModal.saveDemandeDeRevisionInformationsGenerales2, callback);
    },
    saveDemandeDeRevisionInformationsGenerales2: function(callback){
        tenueAJourModal.saveInfoGeneraleCommun2(callback);
    },

    initGenericReponseEvaluateur: function(type_revision_str){
        // désactive les boutons du wizard et active au besoin
        revisionsAdministrativesModal.generiqueReponseEvaluateurInitBoutonsWizard(type_revision_str);

        // générique: init les champs pour avoir les eventlisteners  champs modifiés...
        init_change_event_sous_bloc();

        // force rechargement à la sauvegarde de l'étape
        $('#modal-step-contents > .active').attr('recharger', 'oui');

        // UX: event lister et init des checbox de l'étape
        $('#rep_lettre_reponse_checkbox').on('change', function(e){
            revisionsAdministrativesModal.reponseEvaluateurCheckboxEvent('rep_lettre_reponse_checkbox', 'div_id_rep_lettre_reponse');
        }).change();

        revisionsAdministrativesModal.gerer_etats_conclusion();


        // en fonction du choix de l'évaluateur on affiche les valeurs dans inscriptions proposées, ou on les masque.
        function gere_choix_modification_inscriptions_proposees(){
            let elems_inscriptions_proposees = $('.type-proposees  [valeur-originale]');
            if ($('input[type=radio][name=rep_choix_evaluateur_modifications]:checked').val() == "0") {
                $(elems_inscriptions_proposees).html('-');
            }else{
                $(elems_inscriptions_proposees).each(function(){
                   $(this).html($(this).attr('valeur-originale'));
                });
            }
        }
        $('input[type=radio][name=rep_choix_evaluateur_modifications]').on('change', function(e) {gere_choix_modification_inscriptions_proposees(e);});
        gere_choix_modification_inscriptions_proposees();
        $('.popover-dismiss').popover({
            trigger: 'focus'
        });

        revisionsAdministrativesModal.gerer_champ_rep_langue();
    },

    // // DDR - Etape Réponse de l'évaluateur
    // init// 2025-09-24: obligé de conserver initCorrectionDOficeReponseEvaluateur plutot que le générique
    // du aux références  en bd...
    initDemandeDeRevisionReponseEvaluateur: function(){
        revisionsAdministrativesModal.initGenericReponseEvaluateur('ddr');
    },


    gerer_etats_conclusion: function(){
        function gerer_etats_conclusion_do() {
            $('#div_id_rep_date_acceptation').hide();
                if ($('input[type="radio"][name="rep_conclusion"]:checked').val() == "demandeur_accepte") {
                    $('#div_id_rep_date_acceptation').show();
                }
        }
        $('input[type="radio"][name="rep_conclusion"]').on('change', function () {
            gerer_etats_conclusion_do();
        });
        gerer_etats_conclusion_do();
    },



    // #21367: gestion du champ contenu de la lettre fr/en en fonction du choix de la langue de la réponse.
    gerer_champ_rep_langue: function(){
        function gerer_champ_rep_langue_do(){
            $('#div_id_rep_lettre_reponse_en, #div_id_rep_lettre_reponse_fr').hide();
            $('#div_id_rep_lettre_reponse_'+$('#id_rep_langue').val()).show();
        }
        $('#id_rep_langue').on('change', gerer_champ_rep_langue_do);
        gerer_champ_rep_langue_do();
    },

    reponseEvaluateurCheckboxEvent: function(la_checkbox, le_contenu){
        let lacheckbox = $('#'+la_checkbox);
        let lecontenu = $('#'+le_contenu);
        lecontenu.hide();
        if(lacheckbox.is(':checked')){
            lecontenu.show();
        }
    },


    generiqueReponseEvaluateurInitBoutonsWizard: function(type_revision_str){
        // apellée à l'initialisation de l'étape ainsi qu'à la fermeture de modales de confirmations
        // controle l'état activé/désactivé des boutons sauvegarder/suivants
        // en fonction de l'état de l'étape ou de son contenu
        // désactive le bouton enregistrer et suivant, par défaut.
        $('#btn-wizard-suivant-terminer').prop("disabled", true);
        $('button#btn-wizard-save').prop('disabled', true);  // sera activé quand changement dans le form
        // si l'étape est terminée, on active le bouton terminer.
        let est_reponse_evaluateur_completee = $('#'+type_revision_str+'-reponse-evaluateur-form').data('est_reponse_evaluateur_completee');
        if(est_reponse_evaluateur_completee){
            $('#btn-wizard-suivant-terminer').prop("disabled", false);
        }
        // on teste aussi si le form à été modifié pour afficher le bouton sauvegarder
        if(blocEstModifie($('#'+type_revision_str+'-reponse-evaluateur-form'))){
            $('button#btn-wizard-save').prop('disabled', false);
        }

        var documentscontainter = $('.active > #accordion-documents-section');
        $.each(documentscontainter.find('.ace-input-file'), function (idx, obj) {
            initAceInputFile($(obj), {});
        });
        $('.sous-bloc-form[bloc-editable="False"]').attr('bloc-editable', 'True');


    },



    // save
    saveDemandeDeRevisionReponseEvaluateur: function(callbacksaveDemandeDeRevisionReponseEvaluateur){
        ///////////////
        // désactive les boutons suivants/sauvegarder
        $('#btn-wizard-suivant-terminer').prop("disabled", true);
        $('button#btn-wizard-save').prop('disabled', true);

        ///////////////
        // Demande confirmation avec une modale
        let messageconfirm =
            "La sauvegarde de ce formulaire va générer le document PDF de la réponse \n"+
            "de l'évaluateur ainsi que la lettre de présentation qui seront ajoutés dans la section Documents de la présente \n"+
            "étape (si l'option ici-bas est cochée). \n"+
            "Si vous désirez sauvegarder sans générer ces documents, simplement laisser l'option décochée.\n"+
            "<hr/><input type='checkbox' id='ddr-reponse-confirm-generer-pdf'> Générer et joindre le(s) document(s) PDF ";

        let ddrReponseConfirmModal = {
            id: "ddr-reponse-confirm-modal",
            view: "/core/modal/",
            id_processus: "",
            titre: "Attention",
            titre_supp: "",
            module: "",
            contenuHTML: messageconfirm,
            contenuIcone: 'fa-exclamation-triangle orange vertical-align-middle',
            template: "",
            template_view: "",
            template_depart: "",
            template_depart_view: "",
            url: "",
            taille: "normale",
            resultat: "",
            resultat_depart: "",
            wizard: false,
            sans_x: true,
            callback: function (e) {
                setTimeout(function () {
                    $('#ddr-reponse-modal-confirm-button').off('click').on('click', function () {
                        $(this).parents('.modal').modal('hide');
                        let generer_pdf = $('#ddr-reponse-confirm-generer-pdf').is(':checked');
                        savedocumentReponseEvaluateur('ddr', generer_pdf, callbacksaveDemandeDeRevisionReponseEvaluateur);
                    });

                    // au click du bouton annuler de la modale de confirmation
                    $('#ddr-reponse-modal-annuler-button').on('click', function () {
                        // on reset l'état des boutons de l'étape
                        revisionsAdministrativesModal.generiqueReponseEvaluateurInitBoutonsWizard('ddr');
                    });
                }, 100);
            },
            boutons: [
                {
                    type: "save",
                    label: "Sauvegarder",
                    title: "",
                    classSupp: "btn-primary",
                    afficher: true,
                    id: "ddr-reponse-modal-confirm-button",
                    disabled: false
                },
                {
                    type: "cancel",
                    label: "Annuler",
                    title: "",
                    classSupp: "",
                    id: "ddr-reponse-modal-annuler-button",
                    afficher: true
                }
            ]
        };
        fenetreModal.creerModal(ddrReponseConfirmModal, {});
    },


    //////////////////////////////////////////////////////
    // Recours au tribunal
    //////////////////////////////////////////////////////
    initRecoursAuTribunalInformationsGenerales: function(){
        tenueAJourModal.initInfoGeneraleCommun();
        $('#modal-step1').attr('recharger', 'oui');
        $('button#btn-wizard-save').prop('disabled', true);  // sera activé quand changement dans le form
        var id_evenement = $('#wizard').attr('id-evenement');
        var id_ue = $('#wizard').attr('id-ue');

        // Pas en mode création.
        // En mode édition / Mode Lecture seule (dans TAJ également) quand on revient à l'étape 1
        if(id_evenement && id_ue){
            // Gestion du selecteur demandeur nature / selecteur proprietaire
            let id_proprietaire = $("#recours-au-tribunal").attr('id-demandeur_proprietaire_id');
            // récupération de la liste des propriétaires, avec le potentiel id_proprieraire sélectionné si présent.
            revisionsAdministrativesModal.getDDRProprietairesListe(id_ue, id_proprietaire, function(response){
                $('#rat-form-proprietaire').html(response);
                // simule un changement du sélecteur de demandeur nature, afin d'afficher les bons "sous-champs"
                $('#recours-au-tribunal #demandeur_nature').change();
                // masque la div d'avertissement de sélection d'UE
                $("#rat-form-proprietaire-aucun-id-ue").hide();
                // affiche le formulaire ayant le selecteur
                $("#rat-form-proprietaire").show();
                // le changement du dropdown provoque un changement du fomrulaire,
                // étant toujours dans l'initialisation, on redésactive le bouton de sauvegarde
                $('button#btn-wizard-save').prop('disabled', true);
            });
            // Gestion du selecteur evenement
            let id_evenement = $("#recours-au-tribunal").attr('id-evenement_origine_rat_id');
            // récupération de la liste des evenements, avec le potentiel id_evenement sélectionné si présent.
            revisionsAdministrativesModal.getRATEvenementsListe(id_ue, id_evenement, revisionsAdministrativesModal.callBack_defaut_getRATEvenementsListe);
        }
        // Affichage du selecteur de propriétaire ou du formulaire d'adresse en fonction de la nature du demandeur
        $('#recours-au-tribunal #demandeur_nature').on('change', function(e){
            // masque les deux sections par défaut
            $('#recours-au-tribunal #rat-form-proprietaire-selection').hide();
            $('#recours-au-tribunal #rat-form-demandeur-details').hide();
            if($(this).val()=="0"){
                $('#recours-au-tribunal #rat-form-proprietaire-selection').show();
            }else if($(this).val()=="1"){
                $('#recours-au-tribunal #rat-form-demandeur-details').show();
            }
        });



    },
    saveRecoursAuTribunalInformationsGenerales: function(callback){
        tenueAJourModal.checkDateDeJour(revisionsAdministrativesModal.saveRecoursAuTribunalInformationsGenerales2, callback);
    },
    saveRecoursAuTribunalInformationsGenerales2: function(callback){
        tenueAJourModal.saveInfoGeneraleCommun2(callback);
    },
    //////////////////////////////////////////////////////
    // Correction d'office
    //////////////////////////////////////////////////////
    initCorrectionDOfficeInformationsGenerales: function(){
        tenueAJourModal.initInfoGeneraleCommun();
    }, // initDemandeRevisionInformationsGenerales
    saveCorrectionDOfficeInformationsGenerales: function(callback){
        tenueAJourModal.checkDateDeJour(revisionsAdministrativesModal.saveCorrectionDOfficeInformationsGenerales2, callback);
    },
    saveCorrectionDOfficeInformationsGenerales2: function(callback){
        tenueAJourModal.saveInfoGeneraleCommun2(callback);
    },
    // init // 2025-09-24: obligé de conserver initCorrectionDOficeReponseEvaluateur plutot que le générique
    // du aux références  en bd...
    initCorrectionDOficeReponseEvaluateur: function(){
        revisionsAdministrativesModal.initGenericReponseEvaluateur('cdo');
    },
    saveCorrectionDofficeReponseEvaluateur: function(callbacksaveCorrectionDOfficeReponseEvaluateur){
        ///////////////
        $('#btn-wizard-suivant-terminer').prop("disabled", true);
        $('button#btn-wizard-save').prop('disabled', true);


        ///////////////
        // Demande confirmation avec une modale
        let messageconfirm =
            "La sauvegarde de ce formulaire peut générer le document PDF de la réponse \n"+
            "de l'évaluateur ainsi que la lettre de présentation qui seront ajoutés dans la section Documents de la présente \n"+
            "étape (si l'option ici-bas est cochée). \n"+
            "Si vous désirez sauvegarder sans générer ces documents, simplement laisser l'option décochée.\n"+
            "<hr/><input type='checkbox' id='cdo-reponse-confirm-generer-pdf'> Générer et joindre le(s) document(s) PDF ";

        let cdoReponseConfirmModal = {
            id: "cdo-reponse-confirm-modal",
            view: "/core/modal/",
            id_processus: "",
            titre: "Attention",
            titre_supp: "",
            module: "",
            contenuHTML: messageconfirm,
            contenuIcone: 'fa-exclamation-triangle orange vertical-align-middle',
            template: "",
            template_view: "",
            template_depart: "",
            template_depart_view: "",
            url: "",
            taille: "normale",
            resultat: "",
            resultat_depart: "",
            wizard: false,
            sans_x: true,
            callback: function (e) {
                setTimeout(function () {
                    $('#cdo-reponse-modal-confirm-button').off('click').on('click', function () {
                        $(this).parents('.modal').modal('hide');
                        let generer_pdf = $('#cdo-reponse-confirm-generer-pdf').is(':checked');
                        savedocumentReponseEvaluateur('cdo', generer_pdf, callbacksaveCorrectionDOfficeReponseEvaluateur);
                        // saveCorrectionDofficeReponseEvaluateurGo(callbacksaveCorrectionDOfficeReponseEvaluateur, generer_pdf);
                    });

                    // au click du bouton annuler de la modale de confirmation
                    $('#cdo-reponse-modal-annuler-button').on('click', function () {
                        // on reset l'état des boutons de l'étape
                        revisionsAdministrativesModal.generiqueReponseEvaluateurInitBoutonsWizard('cdo');
                    });
                }, 100);
            },
            boutons: [
                {
                    type: "save",
                    label: "Sauvegarder",
                    title: "",
                    classSupp: "btn-primary",
                    afficher: true,
                    id: "cdo-reponse-modal-confirm-button",
                    disabled: false
                },
                {
                    type: "cancel",
                    label: "Annuler",
                    title: "",
                    classSupp: "",
                    id: "cdo-reponse-modal-annuler-button",
                    afficher: true
                }
            ]
        };

        fenetreModal.creerModal(cdoReponseConfirmModal, {});

    },
    // pour le click d'un résultat de sélection d'UE,
    // apellé depuis explorateur-ue-recherche.js
    callbackSelectionUEpourCDO: function(element_a_clique, evenement_du_click, checkboxEstCoche){
        var id_ue_dernier_click = $(element_a_clique).attr('id-ue');
        var id_ue = id_ue_dernier_click;
        revisionsAdministrativesModal.getCDOEvenement(id_ue, revisionsAdministrativesModal.callBack_defaut_getCDOEvenement);
    },
    // Call ajax qui nous récupère le html de la liste des évènements pour l'ue sélectionnée, fournir un callback pour traiter le retour.
    getCDOEvenement: function(id_ue, callback_getCDOEvenement){
        $.ajax({
            type: "POST",
            dataType: 'json',
            url: "/gestion-roles/revisions-administratives/correction-d-office/informations-generales/evenement/"+id_ue+'/',
            success: function (response) {
                if(response.erreur){
                    infos.ajouterMessageToast({
                        message: response.erreur,
                        messageDuree: 5000,
                        messageCouleur: 'red'
                    });
                    $('#btn-wizard-suivant-terminer').prop("disabled", true);
                    $('button#btn-wizard-save').prop('disabled', true);
                }else{
                    callback_getCDOEvenement(response);
                }
            }
        });
    },
    callBack_defaut_getCDOEvenement: function(response){
        // remplacement du contenu du dom par le html retourné.
        $('#cdo-form-evenement').html(response.html);
        // changement de la date de prise d'effet
        $('[name="date_evenement"]').val(response.date_evenement_origine);
        infos.ajouterMessageToast({
            message: "Date de prise d'effet au rôle changée en fonction de l'évènement détecté automatiquement pour: "+response.date_evenement_origine,
            messageDuree: 3000,
            messageCouleur: 'orange'
        });
        $('[name="date_evenement"]').change();
        $('#btn-wizard-suivant-terminer').prop("disabled", false);
        $('button#btn-wizard-save').prop('disabled', false);
    },


    //////////////////////////////////////////////////////
    // Correction d'erreur d'écriture
    //////////////////////////////////////////////////////
    initCorrectionErreurEcritureInformationsGenerales: function(){
        tenueAJourModal.initInfoGeneraleCommun();
    }, // initDemandeRevisionInformationsGenerales
    saveCorrectionErreurEcritureInformationsGenerales: function(callback){
        tenueAJourModal.checkDateDeJour(revisionsAdministrativesModal.saveCorrectionErreurEcritureInformationsGenerales2, callback);
    },
    saveCorrectionErreurEcritureInformationsGenerales2: function(callback){
        tenueAJourModal.saveInfoGeneraleCommun2(callback);
    },
};


function saveReponseEvaluateurGo(type_revision_str, callbacksaveReponseEvaluateur, generer_pdf){
    // fonction pour gérer la sauvevegarde avec generation pdf des étapes Réponse Évaluateur (CDO et DDR)
    var leform = $('#'+type_revision_str+'-reponse-evaluateur-form');
    let data = leform.serialize();
    data += '&id_evenement=' + $('#wizard').attr('id-evenement');
    if(generer_pdf){
        data += '&generer_pdf=1';
    }
    var url_reponse_evaluateur_go = '';
    if(type_revision_str=='ddr'){
        url_reponse_evaluateur_go = "/gestion-roles/revisions-administratives/demande-revision/reponse-evaluateur/";
    }else {
        url_reponse_evaluateur_go = "/gestion-roles/revisions-administratives/correction-d-office/reponse-evaluateur/";
    }
    wait.start();
    $.ajax({
        type: "POST",
        url: url_reponse_evaluateur_go,
        async: true,
        data: data,
        dataType: 'json',

        success: function (response) {
            if(response.form_valide){
                // Si le statut a changé lors de la sauvegarde, on l'update dans le wizzard.
                if(response.nouveau_statut_id){
                    $('#wizard').attr('id-statut-evenement', response.nouveau_statut_id);
                }
                if (typeof (callbacksaveReponseEvaluateur) !== 'undefined') {
                    response.reponse = 'ok';
                    callbacksaveReponseEvaluateur(response);
                }
                let selecteur_documents_revisions_admin = '';
                if(type_revision_str=='ddr'){
                    selecteur_documents_revisions_admin = '#document-demande-de-revision';
                }else {
                    selecteur_documents_revisions_admin = '#document-correction-d-office';
                }
                if ($(selecteur_documents_revisions_admin).find('.messages-erreurs').length == 0 && $('.step-pane.active').data('step')==10) {
                    $('#btn-wizard-recharger').trigger('click');
                }

            }
            else{
                // Erreur dans la soumission du formulaire
                // on a le form avec les erreurs de retournées, on le raffiche à l'écran
                $('#'+type_revision_str+'-reponse-evaluateur-form').replaceWith(response.html_form);
                // on remène le contenu vers le haut du formulaire
                $('#contenu .slimScrollDiv').slimScroll({ scrollTo : '0px' });
                revisionsAdministrativesModal.initGenericReponseEvaluateur(type_revision_str);
            }
            fenetreModal.fermerModal(''+type_revision_str+'-reponse-confirm-modal');
            wait.stop();

        },
        error: function (xhr, ajaxOptions, thrownError) {
            var response = [];
            if (typeof (callbacksaveReponseEvaluateur) !== 'undefined') {
                response.reponse = 'error';
                callbacksaveReponseEvaluateur(response);
            }
            erreursAjax.traiterErreurs(leform, xhr, thrownError);
            $('.tooltip').remove();
            wait.stop();
        }

    });

}



function savedocumentReponseEvaluateur(type_revision_str, generer_pdf, callback_savedocumentReponseEvaluateur) {
    var sections;
    var idCurrentForm;
    var cle_processus;
    if(type_revision_str=='ddr'){
        sections = $('.step-pane.active #document-demande-de-revision');
        idCurrentForm = 'document-demande-de-revision';
        cle_processus = 'id_demande_de_revision';
    }else{
        sections = $('.step-pane.active #document-correction-d-office');
        idCurrentForm = 'document-correction-d-office';
        cle_processus = 'id_correction_d_office';
    }

    var erreurFichier = $('.step-pane.active #' + idCurrentForm).find('.ace-file-container.selected .ace-error').attr('erreur');
    if (!erreurFichier) {
        erreurFichier = '';
    }
    var getParams = function (currentForm, idCurrentForm, dateEvenement) {
        var params = controlesFormulaires.serialiserFormulaire(currentForm);
        var idRevision = $('#wizard').attr('id-processus');
        var erreurFichier = currentForm.find('.ace-file-container.selected .ace-error').attr('erreur');
        if (!erreurFichier) {
            erreurFichier = '';
        }
        params.push(
            {name: cle_processus, value: idRevision},
            {name: 'erreur_fichier', value: erreurFichier},
            {name: 'date_debut', value: $('#wizard').attr('date-evenement')} // prendre celui du wizard qui vient d'être ajouté par le 'frm-date-evenement'
        );

        return params;
    };

    var getChampUnique = function (currentForm, idCurrentForm) {
        return {};
    };

    var getChampTransfert = function (idCurrentForm) {
        var retour = {};
    };

    var messageToast = {};

    let callback_sauvegarderFormulairesCoteServeur = function(response){
        console.log(response);
        if(response.reponse == "ok"){
            saveReponseEvaluateurGo(type_revision_str, callback_savedocumentReponseEvaluateur, generer_pdf);
        }
    };
    tenueAJourModal.sauvegarderFormulairesCoteServeur(callback_sauvegarderFormulairesCoteServeur, sections, getParams, getChampUnique, getChampTransfert, messageToast, -1);
}

function initRapportRevisionAdministrative(sectionElem) {
    wait.start();
    let idRapport = sectionElem.find('[name=hid-id-rapport]').val();
    let idRapportGroupe = sectionElem.find('[name=hid-id-rapport-groupe]').val();
    let filtresDefJson = sectionElem.find('[name="hid-filtres-def"]').val();
    let columnsDefJson = sectionElem.find('[name="hid-columns-def"]').val();
    let tableFiltres = sectionElem.find('.table-filtres');

    let tableElem = sectionElem.find('#table-revisions-administratives');
    let filtres = $.extend(true, {}, listeFiltresRapport);
    mergeFiltresAvecJson(filtres, filtresDefJson);
    tableElem.data('filtres', filtres);

    tableElem.data('table-filtres', tableFiltres);
    tableElem.data('id-rapport', idRapport);

    tableFiltres.data('table-elem', tableElem);

    let tableTemplate = tableElem.closest('.table-template');
    let columnsDef = JSON.parse(columnsDefJson);
    for (let i = 0; i < columnsDef.length; i++) {
        if (columnsDef[i].render) {
            let runStr = columnsDef[i].render;
            columnsDef[i].render = new Function("data", "type", "row", runStr);
        }
    }

    let columnsDefAsg = $.extend(true, {}, columnsDef);
    tableElem.data('colonnesDef', columnsDefAsg);
    let order = [];
    let fct_importer_data = function (detruireTable) {
        let colonnesDef = tableElem.data('colonnesDef');
        let chargerDonnees = detruireTable;

        let pageLength = 10;
        let table = initTableDatatable(tableElem, {
            ajax: {
                url: '/gestion-entreprise/gestion-rapport/charger/',
                data: function (d) {
                    d.id_rapport = idRapport;
                    buildFiltresSelectionContenu(tableElem);

                    let listeFiltresDef = tableElem.data('filtres');
                    let listeFiltres = epurerListeFiltresPost(listeFiltresDef);
                    d.listeFiltres = JSON.stringify(listeFiltres);
                    d.colonnesDef = JSON.stringify(colonnesDef);
                    d.id_municipalite = $('#adm-liste-ville').val();
                    //13000
                    if ($('#query-builder').length != 0) {
                        let listeFiltresQueryBuilder = $('#query-builder').queryBuilder('getSQL', false, true);
                        d.listeFiltresQueryBuilder = JSON.stringify(listeFiltresQueryBuilder, null, 2);
                        d.idMunicipalite = $("#id_municipalite_sig").val();
                    }
                },
                type: "POST"
            },
            async: false,
            destroy: detruireTable,
            dom: '<"datatables-top-pagination"li>T<"datatables-menu-actions">Bfrtip',
            info: 'Affichage des &eacute;v&eacute;nements _START_ &agrave; _END_ sur _TOTAL_',
            order: order,
            paging: true,
            deferLoading: (chargerDonnees ? null : 0),
            pageLength: pageLength,
            processing: false,
            responsive: false,
            scrollCollapse: true,
            scrollX: true,
            searching: false,
            serverSide: true,
            tableTools: {
                "aButtons": ["excel"]
            },
            columnDefs: columnsDef,
            buttons: [
                'colvis',
                'colvisRestore',
            ],
            fixedColumns: {
                leftColumns: 5,
            },

            createdRow: function (row, data) {
                $(row).attr("data-id_evenement", data.id_evenement);
                $(row).attr("data-id_ue", data.id_ue);
                $(row).attr("data-id_type_evenement", data.id_type_evenement);
                $(row).attr("data-etape", data.id_etape_processus);
                $(row).attr("data-id_municipalite", data.id_municipalite);
                $(row).attr("data-date_evenement", data.date_evenement);
                $(row).attr("data-id_statut_evenement", data.id_statut_evenement);
                $(row).attr("data-bool_visible", data.bool_visible);

                if (data.nb_evenements_ouverts_dr > 1) {
                    $(row).children().css('background', 'yellow');
                }

            },
            initComplete: function (settings, json) {
                const keyLocalStorage = getKeyLocalStorage(settings.nTable)
                getNbrColonneMasquees(keyLocalStorage);
                tableElem.find('tbody').on('click', '.check-taj', function () {
                    tenueAJour.cliquerCaseCocherLigneEvenement(this, table);
                });

                tableElem.closest('.table-template').find('.datatables-menu-actions').on('click', '[name=check-tj-select-all]', function () {
                    let boutonsActionDisabled = controlesFormulaires.selectAll(tableElem, $(this));
                    let conteneur = $(this).closest('.table-template');
                    tenueAJour.activerDesactiverBoutonsRuban(conteneur, boutonsActionDisabled);
                });
            },
            headerCallback: function (thead, data, start, end, display) {
                tableTemplate.find(".datatables-menu-actions").load("/gestion-roles/tenue-a-jour/evenements/actions-sur-table/?" + $.param({
                    id_rapport: idRapport
                }),
                    function () {
                        bootstrapOn.initTooltips();
                        let conteneur = $(this);
                        let disabled = table.data().count() <= 0;
                        // Sans résultat dans un tableau de rapport, on désactive les boutons
                        conteneur.find('[name=btn-tj-exporter-excel]').prop("disabled", disabled);

                        //Désactive tous les boutons
                        conteneur.find('.checkall-taj').parent().children().hide();
                        conteneur.find('.checkall-taj').show();
                        conteneur.find('.checkall-taj span').html("Sélectionner tout");

                        conteneur.find('.checkall-taj').show();
                        conteneur.find('[name=btn-tj-supprimer]').show();
                        conteneur.find('[name=btn-tj-assigner-et-etat]').show();
                        conteneur.find('[name=button-ddr-delai-supplementaire]').show();
                        conteneur.find('[name=btn-tj-afficher-dans-explorateur]').show();
                    });
            },
            drawCallback: function (response) {
                if (response.json) {
                    if (response.json.reponse) {
                        infos.ajouterMessageToast({
                            message: response.json.reponse,
                            messageDuree: 5000,
                        });
                    }
                }
            }
        });
        $(table).on('processing.dt', function (e, settings, processing) {
            wait.processing(processing, '', '', 0);
        });

        // On sélectionne et désélectionne des évènements dans la grille par clic sur la rangée (CTRL, MAJ).
        table.on('select', function (e, dt, type, indexes) {
                let $selecteur = $(this);
                let checked = true;
                tenueAJour.activerActionsSurEvenementGrille($selecteur, checked, indexes);
            })
            .on('deselect', function (e, dt, type, indexes) {
                let $selecteur = $(this);
                let checked = false;
                tenueAJour.activerActionsSurEvenementGrille($selecteur, checked, indexes);
            });
        $('[name=ajustement-apres-body]').html('');
        tableElem.find('tfoot').hide();
        tableElem.find('.datatables-menu-actions').hide();
    };

    tableElem.data('fct-importer-data', fct_importer_data);

    for (let i = 0; i < columnsDef.length; i++) {
        tableTemplate.find('tfoot tr').append('<td></td>');
    }
    chargerFiltresEtDonnees(tableElem, true);
    tableTemplate.off("click", '.btn-tj-exporter-excel').on('click', '.btn-tj-exporter-excel', () =>{
        export_xls_taj_rapport(tableElem, "/gestion-entreprise/gestion-rapport/export_xls_rapport/");
    });
    tableTemplate.off("click", '.btn-tj-supprimer').on("click", '.btn-tj-supprimer', function () {
        supprimerRevisionAdministrative($(this));
    });
    tableTemplate.off("click", '.btn-tj-exporter-google-map').on('click', '.btn-tj-exporter-google-map', () => {
        export_google_map_taj_rapport(tableElem);
    });
    tableTemplate.off("click", '[data-action]').on("click", '[data-action]', function () {
        let element = $(this).data('action');
        if (element === 'btn-tj-afficher-dans-explorateur') {
            afficherTAJDansExplorateur(true);
        }
        if (element === 'rafraichir-donnees') {
            let url = $(this).data('url');
            let success_cb = function(resp) {
                let modal = $('#modal-rafraichir-donnees');
                $(modal).find('.modal-body').html(resp);
                $(modal).modal('show');
            };
            call_ajax(url, 'GET', null, success_cb);
        }
        if (element === 'button-ddr-delai-supplementaire') {
            ddrButtonCallbackDelaiSupplementaire();
        }
        if (element === 'btn-tj-assigner-et-etat') {
            tenueAJourModal.modalAssignerEtEtat();
        }
    });
    init_date_picker(tableFiltres);
    init_dateRangePicker(tableFiltres);
    initEventFiltres(filtres, tableFiltres);
    let estquilibration = idRapportGroupe == 10 ? '-'+idRapport+'' : '' ;
    $('#table-evenements'+estquilibration+'').multiSelectTable({
        unselectOn: idRapport == 25 ? '' : 'body',
        keepSelection: false
    });

    initSelectDependant(tableFiltres, filtres);

    wait.stop();
}

function afficherRevisionAdministrativeDansExplorateur() {
    let table = $('#table-revisions-administratives').DataTable();
    let unitesEvaluation = table.rows('.selected').data('id_ue');
    let listeUe = [];
    $.each(unitesEvaluation, function (idx, value) {
        let idUe = value['id_ue'];
        let idMunicipalite = value['municipalite'].split('-')[0];
        let matricule = value['matricule'];
        let adresse = value['adresse_complete_ue'];
        let dateEvenement = value['date_reception'];
        let dateEvenementComplet = value['date_reception'];

        let ue = {
            idUe: idUe,
            idMunicipalite: idMunicipalite,
            matricule: matricule,
            adresse: adresse,
            dateEvenement: dateEvenement,
            dateEvenementComplet: dateEvenementComplet
        };
        if (ue !== '') listeUe.push(ue);
    });

    let params = {
        idModule: 31,
        listeUe: JSON.stringify(listeUe)
    };

    OpenWindowWithPost("/", params);
}

function supprimerRevisionAdministrative() {
    if (!$('#revision-modal-supprimer-evenement').length) {
        let  nb_selected = $('#table-revisions-administratives').find('tr:not(.entete-table-liee)').find('input[type="checkbox"]:checked').length;
        let donnees = (nb_selected > 1 ? ' ces ' + nb_selected + ' évènements ' : ' cet évènement ');

        let variableSupprimerEvenement = {
            id: "revision-modal-supprimer-evenement",
            view: "/core/modal/",
            id_processus: "",
            titre: "Souhaitez-vous vraiment supprimer" + donnees + " ?",
            titre_supp: "",
            module: "",
            contenuHTML: '<h5 class="modal-title red vertical-align-middle">Les données seront détruites de façon permanente</h5><p>',
            contenuIcone: 'fa-exclamation-triangle orange vertical-align-middle',
            template: "",
            template_view: "",
            template_depart: "",
            template_depart_view: "",
            url: "",
            taille: "normale",
            resultat: "",
            resultat_depart: "",
            wizard: false,
            sans_x: true,
            callback: modalSupprimerEvenementRevisionAdministrative,
            boutons: [
                {
                    type: "delete",
                    label: "Oui",
                    title: "",
                    classSupp: "btn-danger",
                    afficher: true,
                    id: "proceder-supprimer-evenement",
                },
                {
                    type: "cancel",
                    label: "Non",
                    title: "",
                    classSupp: "",
                    afficher: true
                }
            ]
        };

        setTimeout(function () {
            fenetreModal.creerModal(variableSupprimerEvenement, {});
        }, 0);
    } else {
        $('#revision-modal-supprimer-evenement').modal('show');
    }
}

function modalSupprimerEvenementRevisionAdministrative() {
    $('#proceder-supprimer-evenement').off('click').on('click', function () {
        let listeEvenement = [];
        let listeFormulaires = $('#table-evenements,.table-evenements').find('tr:not(.entete-table-liee)').find('input[type="checkbox"]:checked');
        listeFormulaires.each(function () {
            let row = $(this).closest('tr');
            let idEvenement = row.attr('data-id_evenement');
            listeEvenement.push(idEvenement);
        });

        let params = {
            liste_evenement: JSON.stringify(listeEvenement)
        };

        wait.start();

        let jqxhr = $.ajax({
            type: "POST",
            url: "/gestion-roles/evenement-supprimer/",
            data: params,
            dataType: 'html'
        });
        jqxhr
            .done(function (response) {
                let reponse = JSON.parse(response);
                if (reponse.response === 'ok') {
                    refreshDatatables();
                    wait.stop();
                    fenetreModal.fermerModal("revision-modal-supprimer-evenement");
                    messageToastCompteur = 0;
                    infos.ajouterMessageToast({
                        message: reponse.message,
                        messageDuree: 5000
                    });
                } else {
                    erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', '', reponse.message);
                    messageToastCompteur = 0;
                    infos.ajouterMessageToast({
                        message: reponse.message,
                        messageCouleur: 'red',
                        messageDuree: 5000
                    });
                    wait.stop();
                }
            });
        jqxhr
            .fail(function (jqxhr, textStatus, errorThrown) {
                wait.stop();
                erreursAjax.afficherErreurGenerique('#erreurs-generiques', 'append', jqxhr, errorThrown);
                messageToastCompteur = 0;
                infos.ajouterMessageToast({
                    message: "Erreur de suppression d'évènement",
                    messageDuree: 5000,
                    messageCouleur: "red"
                });
                $('#proceder-supprimer-evenement').remove();
                $('[data-dismiss="modal-fermer"]').prop('innerText', 'Fermer');
                wait.stop();
            });
    });
}


// Bouton dans le ruban pour les délais
function ddrButtonCallbackDelaiSupplementaire(){
    let table = $('#table-revisions-administratives').DataTable();
    let unitesEvaluation = table.rows('.selected').data('id_ue');
    let listeUe = [];
    let erreurTypeEvenement = false;
    $.each(unitesEvaluation, function (idx, value) {
        let id_type_evenement = value['id_type_evenement'];
        let id_evenement = value['id_evenement'];
        if(id_type_evenement!="61"){
            erreurTypeEvenement=true;
        }
        let ue = {
            id_evenement: id_evenement,
            id_type_evenement: id_type_evenement
        };
        if (ue !== '') listeUe.push(ue);
    });
    if(erreurTypeEvenement){
        alert('Vous ne pouvez sélectionner uniquement des demandes de révisions afin de définir une date de délai supplémentaire.');
    }else{
        ddrModaleDelaiSupplementaire(listeUe);
    }
}

function ddrModaleDelaiSupplementaire(listeUe){
    // Modale init
    function ddrModaleDelaiSupplementaireInitCallback(){
        init_date_picker($("#ddr-delai-supplementaire-modale"));
        // lors du changement du champ date
        $('#ddr-delai-supplementaire-date').off('change').on('change', function(){
           let date = $(this).val();
           if (date != '') {
                // si une valeur est définie, on active et définit le callback du bouton de sauvegarde
                $('#btn-save-ddr-delai-supplementaire').prop("disabled", false);
                $('#btn-save-ddr-delai-supplementaire').off('click').on("click", function(){ddrModaleDelaiSupplementaireSave({'date': date, 'listeUe':listeUe});});
            }
        });
    }

    // Sauvegarde modale
    function ddrModaleDelaiSupplementaireSave(params){
        $('#btn-save-ddr-delai-supplementaire').prop("disabled", true);
        wait.start();
        var data = {'data':JSON.stringify(params)};

        $.ajax({
            type: "POST",
            url: "/gestion-roles/revisions-administratives/demande-revision/demande-de-revision-ajax-save-date-delai-supplementaire/",
            async: true,
            data: data,
            dataType: 'json',
            success: function (response) {
                console.log(response);
                wait.stop();
                if(response.erreurs){
                    infos.ajouterMessageToast({
                        message: response.erreurs.join('<br/>'),
                        messageCouleur: 'red',
                        messageDuree: 5000
                    });
                }else{
                    infos.ajouterMessageToast({
                        message: "Délais supplémentaires ajoutés",
                        messageDuree: 0,
                        messageCouleur: 'green'
                    });
                    $('#table-revisions-administratives').DataTable().ajax.reload(function(){
                        wait.stop();
                    });
                    fenetreModal.fermerModal('ddr-delai-supplementaire-modale');
                }
            },
            error: function (xhr, ajaxOptions, thrownError) {
                wait.stop();
                infos.ajouterMessageToast({
                    message: 'Une erreur s\'est produite. Contactez un administrateur.',
                    messageDuree: 0
                });
            }
        });//ajax;
    }

    // config modale
    let modalHtml = `
        <div>
            <p>Sélectionner une date future pour le délai supplémentaire. Ceci écrasera les valeurs de date de délai supplémentaire existants si existant.</p>
            <label for="ddr-delai-supplementaire-date">Date pour le délai supplémentaire :</label><input id="ddr-delai-supplementaire-date" name="ddr-delai-supplementaire-date" type="date" class="datepicker">
        </div>
    `;
    let variableModal = {
        id: "ddr-delai-supplementaire-modale",
        view: "/core/modal/",
        processus_id: "",
        titre: "Définir un délai supplémentaire",
        contenuHTML: modalHtml,
        contenuIcone: "fa fa-exclamation-triangle",
        sans_x: false,
        callback:ddrModaleDelaiSupplementaireInitCallback,
        taille: "normale",
        wizard: false,
        boutons: [
            {
                type: "cancel",
                label: "Annuler",
                title: "",
                classSupp: "",
                afficher: true
            },

            {
                type: "save",
                label: "Sauvegarder",
                title: "",
                classSupp: "btn-primary",
                afficher: true,
                id: "btn-save-ddr-delai-supplementaire",
                disabled: true
            }
        ]
    };

    // Ouverture modale
    setTimeout(function () {
        let customParams = {};
        fenetreModal.creerModal(variableModal, customParams, ddrModaleDelaiSupplementaireInitCallback);
    });
}
